import { Helmet } from 'react-helmet-async';
import BoardView from './components/BoardView';
import { isStakeholder } from '../../utils/share';

export default function MyTaskBoardPage() {
  return (
    <>
      <Helmet>
        <title> {isStakeholder() ? "Issues Register" : "My Task"} </title>
      </Helmet>
      <BoardView />
    </>
  );
}
